import { SvgIcon, SvgIconProps } from "@mui/material";

export default function CopyIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 31"
      style={{ width: "35px", cursor: "pointer" }}
    >
      <g fill="none" fillRule="evenodd" transform="translate(-412 -399)">
        <g transform="translate(412 399)">
          <rect
            width="15.5"
            height="15.5"
            x="10.333"
            y="10.333"
            stroke="rgb(216, 216, 216)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.925"
            rx="2.567"
          />
          <path
            stroke="rgb(216, 216, 216)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.925"
            d="M20.667 10.333V7.75a2.583 2.583 0 0 0-2.584-2.583H7.75A2.583 2.583 0 0 0 5.167 7.75v10.333a2.583 2.583 0 0 0 2.583 2.584h2.583"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
